/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ToolMetadata, ToolMetadata$inboundSchema } from "./toolmetadata.js";

/**
 * Result of an authoritative tool metadata batch upsert.
 */
export type SetToolMetadataBatchResult = {
  /**
   * The number of stored tools soft-deleted because they were absent from the payload
   */
  deleted: number;
  /**
   * The stored tool metadata after the upsert
   */
  tools: Array<ToolMetadata>;
};

/** @internal */
export const SetToolMetadataBatchResult$inboundSchema: z.ZodMiniType<
  SetToolMetadataBatchResult,
  unknown
> = z.object({
  deleted: z.int(),
  tools: z.array(ToolMetadata$inboundSchema),
});

export function setToolMetadataBatchResultFromJSON(
  jsonString: string,
): SafeParseResult<SetToolMetadataBatchResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SetToolMetadataBatchResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SetToolMetadataBatchResult' from JSON`,
  );
}
